import { useState } from "react";
import { toast } from "sonner";
import { Check, Crown } from "lucide-react";
import { errMsg, startCheckout } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const PLANS = [
  { key: "member_monthly", tier: "member", name: "Member", price: "9.99",
    perks: ["Online dating around the world", "Unlimited messaging", "Worldwide search & filters", "Tip with tokens"] },
  { key: "vip_monthly", tier: "vip", name: "VIP", price: "19.99",
    perks: ["Everything in Member", "Watch & host live cams", "Cash exchange: send money to members", "Sell 18+ exclusive content (keep 90%)", "Gold VIP badge"] },
];

export default function Membership() {
  const { user } = useAuth();
  const [busy, setBusy] = useState("");
  const buy = async (k) => {
    setBusy(k);
    try { await startCheckout(k); } catch (e) { toast.error(errMsg(e)); setBusy(""); }
  };
  return (
    <main className="mx-auto max-w-6xl px-5 py-16 lg:px-8" data-testid="membership-page">
      <p className="eyebrow mb-3">Membership</p>
      <h1 className="font-display mb-4 text-5xl sm:text-6xl">Choose your <span className="italic text-red-600">status.</span></h1>
      <p data-testid="current-tier" className="mb-14 text-zinc-400">
        Current plan: <span className="uppercase text-white">{user.membership}</span>
        {user.membership_expires && user.membership !== "free" ? ` · renews ${new Date(user.membership_expires).toLocaleDateString()}` : ""}
      </p>
      <div className="grid gap-6 md:grid-cols-2">
        {PLANS.map((p) => (
          <div key={p.key} data-testid={`plan-${p.tier}`} className={`card-lux relative p-10 ${p.tier === "vip" ? "border-red-600/50 shadow-[0_0_60px_rgba(229,9,20,0.12)]" : ""}`}>
            {p.tier === "vip" && <Crown className="absolute right-8 top-8 h-7 w-7 text-amber-400" />}
            <p className="eyebrow mb-2">{p.name}</p>
            <p className="font-display text-7xl">${p.price}<span className="text-xl text-zinc-500"> / month</span></p>
            <ul className="my-8 space-y-3">
              {p.perks.map((x) => <li key={x} className="flex items-center gap-3 text-sm text-zinc-300"><Check className="h-4 w-4 text-red-500" />{x}</li>)}
            </ul>
            <button data-testid={`plan-${p.tier}-subscribe-btn`} disabled={!!busy} onClick={() => buy(p.key)}
              className={`w-full rounded-full py-3.5 font-semibold disabled:opacity-50 ${p.tier === "vip" ? "btn-red" : "border border-white/25 transition-colors hover:bg-white hover:text-black"}`}>
              {busy === p.key ? "Redirecting…" : user.membership === p.tier ? "Extend 30 days" : `Subscribe · $${p.price}/mo`}
            </button>
          </div>
        ))}
      </div>
      <p className="mt-8 text-xs text-zinc-600">Secure checkout by Stripe. Billed monthly. All members must pass ID verification.</p>
    </main>
  );
}
